module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset_wrapper"
  }, [_c('div', {
    staticClass: "reset_container"
  }, [_c('div', {
    staticClass: "reset_option"
  }, [_c('h4', [_vm._v("Change Password")]), _vm._v(" "), _c('el-form', {
    ref: "changePassword",
    attrs: {
      "model": _vm.changePassword,
      "status-icon": "",
      "rules": _vm.changePasswordRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "current_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Current Password ＊"
    },
    model: {
      value: (_vm.changePassword.current_pwd),
      callback: function($$v) {
        _vm.changePassword.current_pwd = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "changePassword.current_pwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "new_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "New Password ＊"
    },
    on: {
      "focus": function($event) {
        _vm.focus_on = true;
        _vm.init = true
      },
      "blur": function($event) {
        _vm.focus_on = false
      }
    },
    model: {
      value: (_vm.changePassword.new_pwd),
      callback: function($$v) {
        _vm.changePassword.new_pwd = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "changePassword.new_pwd"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_off),
      expression: "show_off"
    }],
    staticClass: "notice"
  }, [_c('p', {
    class: _vm.getClass('type1')
  }, [_vm._v("8 to 25 characters")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type2')
  }, [_vm._v("Upper & lowercase letters")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type3')
  }, [_vm._v("At least one number")]), _vm._v(" "), _c('p', {
    class: _vm.getClass('type4')
  }, [_vm._v("Can not use special numeric except !@#$%^&*()?\n              <>._-")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "re_new_pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Retype New Password ＊"
    },
    model: {
      value: (_vm.changePassword.re_new_pwd),
      callback: function($$v) {
        _vm.changePassword.re_new_pwd = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "changePassword.re_new_pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('a', {
    staticClass: "save",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19c283ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/resetcode.vue
// module id = 825
// module chunks = 1